import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { app } from './startFirestore';
import { environmentType, deploymentEnvironment, emulatorPorts } from '../config';

export const functions = getFunctions(app);

// Check and use emulator if in development environment and local deployment
export const checkAndUseEmulator = async () => {
    if (environmentType === 'development' && deploymentEnvironment === 'local') {
        try {
            const response = await fetch(`http://localhost:${emulatorPorts.firestore}`);
            if (response.ok) {
                connectFunctionsEmulator(functions, 'localhost', emulatorPorts.functions);
                console.log('Connected to Firebase Functions emulator');
            }
        } catch (error) {
            console.log('Firebase Functions emulator not connected');
        }
    }
};

// Call this function at the top level of your app
checkAndUseEmulator();